import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as XLSXSTYLE from 'xlsx-js-style';
import * as ExcelJS from 'exceljs';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root',
})
export class ExcelService {
  uploadedData: any;
  uploadedFile: any;
  constructor() {}

  private getColumnFromIndex(index: number) {
    return String.fromCharCode(index + 65);
  }

  private getWorkbook(json: any[], headers: string[], excelFileName: string) {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, {});

    const range = XLSX.utils.decode_range(worksheet['!ref'] as string);
    for (let C = range.s.c; C <= range.e.c; C++) {
      const address = `${XLSX.utils.encode_col(C)}1`; // <-- first row
      if (!worksheet[address]) {
        continue;
      }
      worksheet[address].v = headers[C];
    }
    const wscols: any = [];
    for (const [index, head] of headers.entries()) {
      // columns length added
      let wch = head.length + 7;

      switch (head.toLowerCase()) {
        case 'cc':
          wch = 3;
          break;
        case 'van dt':
          wch = 12;
          break;
        case 'part no':
          wch = 14;
          break;
        case 'kanban':
          wch = 8;
          break;
        case 'qpc':
        case 'spc':
          wch = 8;
          break;
        case 'fa min original':
        case 'fa max original':
        case 'fa min final':
        case 'fa max final':
          wch = head.length;
          break;
        case 'updated dt':
          wch = 20;
          break;
        case 'user':
          wch = 30;
          break;
        case 'comments':
          wch = 140;
          break;
        case 'remarks':
        case 'errors':
        case 'error':
          wch = 50;
          break;
      }

      if (
        !excelFileName.includes('flal') &&
        head.toUpperCase().includes('DT') &&
        !head.toUpperCase().includes('UPDATE')
      ) {
        for (let rowIndex = 0; rowIndex < range.e.r; rowIndex++) {
          // console.log(index + '' + (rowIndex + 2));
          const address = `${XLSX.utils.encode_col(index)}${rowIndex + 2}`;
          // console.log({ address }, worksheet[address].v);

          if (!(String(new Date(worksheet[address].v)) === 'Invalid Date')) {
            if (this.checkExcelFileName(excelFileName)) {
              if (worksheet[address].v !== null) {
                if (this.checkExcelColumnName(head)) {
                  worksheet[address].t = 'n';                        // number (Excel date)
                  worksheet[address].v = this.toExcelDate(worksheet[address].v);        // Excel serial date
                  worksheet[address].z = 'mm/dd/yyyy';               // display format
                } else {
                  worksheet[address].t = 'd';
                }
              }
            } else {
              if (worksheet[address].v !== null) worksheet[address].t = 'd';
            }
          }
        }
      }

      wscols.push({ wch });
    }
    worksheet['!cols'] = wscols;

    // console.log(worksheet);

    const workbook: XLSX.WorkBook = {
      Sheets: { sheet_1: worksheet },
      SheetNames: ['sheet_1'],
    };

    return workbook;
  }
  // This function is for Daownload grid data in all screen
  private getWorkbook1(json: any[], headers: string[], excelFileName: string) {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, {});

    const range = XLSX.utils.decode_range(worksheet['!ref'] as string);
    for (let C = range.s.c; C <= range.e.c; C++) {
      const address = `${XLSX.utils.encode_col(C)}1`; // <-- first row
      if (!worksheet[address]) {
        continue;
      }
      worksheet[address].v = headers[C];
    }
    const wscols: any = [];
    for (const [index, head] of headers.entries()) {
      // columns length added
      let wch = head.length + 7;

      switch (head.toLowerCase()) {
        case 'cc':
          wch = 3;
          break;
        case 'van dt':
          wch = 12;
          break;
        case 'part no':
          wch = 14;
          break;
        case 'kanban':
          wch = 8;
          break;
        case 'qpc':
        case 'spc':
          wch = 8;
          break;
        case 'fa min original':
        case 'fa max original':
        case 'fa min final':
        case 'fa max final':
          wch = head.length;
          break;
        case 'updated dt':
          wch = 20;
          break;
        case 'user':
          wch = 30;
          break;
        case 'comments':
          wch = 140;
          break;
        case 'remarks':
        case 'errors':
        case 'error':
          wch = 50;
          break;
      }

      if (
        !excelFileName.includes('flal') &&
       (head.toUpperCase().includes('DT') || head.toUpperCase().includes('STOCKING DATE') || this.checkExcelColumnName(head))  &&
        !head.toUpperCase().includes('UPDATE')
      ) {
        for (let rowIndex = 0; rowIndex < range.e.r; rowIndex++) {
          // console.log(index + '' + (rowIndex + 2));
          const address = `${XLSX.utils.encode_col(index)}${rowIndex + 2}`;
          // console.log({ address }, worksheet[address].v);

          if (!(String(new Date(worksheet[address]?.v)) === 'Invalid Date')) {
            if (this.checkExcelFileName(excelFileName)) {
              if (worksheet[address].v !== null) {
                if (this.checkExcelColumnName(head)) {
                  worksheet[address].t = 'n';                        // number (Excel date)
                  worksheet[address].v = this.toExcelDate(worksheet[address].v);        // Excel serial date
                  worksheet[address].z = 'mm/dd/yyyy';               // display format
                } else {
                  worksheet[address].t = 'd';
                }
              }
            } else {
              if (worksheet[address].v !== null) worksheet[address].t = 'd';
            }
          }
        }
      }

      wscols.push({ wch });
    }
    worksheet['!cols'] = wscols;
    const headers1 = worksheet['!cols'];
    for (let i = 0; i < headers1.length; i++) {
      const headerName = XLSX.utils.encode_cell({ r: 0, c: i });
      // Function to check if header name matches the condition
      function isTextColumn(headerName: string): boolean {
        return (
          headerName === 'Part No' ||
          headerName === 'PART NO' ||
          headerName === 'Kanban' ||
          headerName === 'KANBAN' ||
          headerName === 'Order Code'
        );
      }

      if (isTextColumn(worksheet[headerName].v)) {
        console.log('inside convertion logic');
        // Set the column format to text
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        for (let j = range.s.r + 1; j <= range.e.r; j++) {
          // Start from the second row
          const cellAddress = XLSX.utils.encode_cell({ r: j, c: i });
          if (worksheet[cellAddress]) {
            worksheet[cellAddress].z = '@'; // Set format to text
          }
        }
      }
   
      function isNumColumn(headerName: string): boolean {
        return (
          headerName === 'RENBAN QTY(PCS)' ||
          headerName === 'MODULE QTY(PCS)' ||
          headerName === 'DAILY QTY (PCS)' ||
          headerName === 'SYS ADJ'         ||
          headerName === 'BOA'             ||
          headerName === 'MAN ADJ'
        );
      }
      if (isNumColumn(worksheet[headerName].v)) {
        
        
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        for (let j = range.s.r + 1; j <= range.e.r; j++) {
       
          const cellAddress = XLSX.utils.encode_cell({ r: j, c: i });
          const cell = worksheet[cellAddress];
        
          if (cell && !isNaN(cell.v)) {
            cell.t = 'n';   
            cell.z = '0';      
            cell.v = Number(cell.v); 
          }
        }
      }

    }

     console.log("headers",headers);
    
    
 const devanHeader = ['STOCKING DATE', 'STOCKED', 'CONTAINER', 'RENBAN QTY(PCS)', 'MODULE', 'MODULE QTY(PCS)', 'DAILY QTY (PCS)'];


 if( headers.length === devanHeader.length &&
  headers.every((val, index) => val === devanHeader[index])){
  const workbook: XLSX.WorkBook = {
    Sheets: { "DevanningHistory": worksheet },
    SheetNames: ['DevanningHistory'],
  };
  return workbook;
}else{
   const workbook: XLSX.WorkBook = {
    Sheets: { sheet_1: worksheet },
    SheetNames: ['sheet_1'],
  };
  return workbook;
}
    

    
  }

  private unwrapExcelValue(value: any): any {
    if (value == null) return '';
    if (value instanceof Date) return value;
    if (typeof value !== 'object') return value;

    // SheetJS-like cell object
    if ('v' in value) return value.v ?? '';

    // If only style/meta object is passed accidentally, keep blank
    const metaKeys = ['t', 's', 'z', 'w', 'r', 'h'];
    const keys = Object.keys(value);
    if (keys.length && keys.every(k => metaKeys.includes(k))) return '';

    return '';
  }

  // This function is only for flal
  // It sets a few fields readonly - so that user cannot edit those
  public downloadFLALExcel(json: any[], excelFileName: string, headers: string[]) {
    const workbook = new ExcelJS.Workbook();
    const workSheet = workbook.addWorksheet('FluctuationAllowance');

    workSheet.addRow(headers);

    for (const row of json) {
      const sourceValues = Object.values(row);

      const rowValues = headers.map((header, i) => {
        const byHeader = row?.[header];
        const raw = byHeader !== undefined ? byHeader : sourceValues[i];
        return this.unwrapExcelValue(raw);
      });

      const addedRow = workSheet.addRow(rowValues);

      if (!excelFileName.includes('error')) {
        headers.forEach((header, i) => {
          if (!this.checkExcelColumnName(header)) return;

          const cell = addedRow.getCell(i + 1);
          const raw = cell.value as any;
          if (raw == null || raw === '') return;

          let serial: number | null = null;

          if (typeof raw === 'string') {
            const datePart = raw.trim().split(' ')[0];
            const m = datePart.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
            if (m) {
              serial = this.toExcelDate(`${Number(m[1])}/${Number(m[2])}/${Number(m[3])}`);
            }
          } else if (raw instanceof Date && !isNaN(raw.getTime())) {
            serial = this.toExcelDate(`${raw.getMonth() + 1}/${raw.getDate()}/${raw.getFullYear()}`);
          }

          if (serial !== null) {
            cell.value = serial;
            cell.numFmt = 'mm/dd/yyyy';
          }
        });
      }
    }

    for (let iCount = 0; iCount < headers.length; iCount++) {
      let width = headers[iCount].length;

      switch (headers[iCount].toLowerCase()) {
        case 'cc':
          width = 3;
          break;
        case 'van dt':
          width = 12;
          break;
        case 'part no':
          width = 14;
          break;
        case 'kanban':
          width = 8;
          break;
        case 'qpc':
          width = 7;
          break;
        case 'comments':
          width = 20;
          break;
        case 'remarks':
          width = 50;
          break;
      }

      workSheet.getColumn(iCount + 1).width = width;
      workSheet.getColumn(iCount + 1).alignment = { wrapText: true };
    }

    // const char = String.fromCharCode(0 + 65);

    // for (let j = 0; j < json.length; j++) {
    //   const cellAddr = char + '' + (j + 2);

    //   workSheet.getCell(cellAddr).type = 4;
    // }

    const func = async () => {
      // FA Min Final till end
      for (let index = 7; index < headers.length; index++) {
        const char = String.fromCharCode(index + 65);

        for (let j = 0; j < json.length; j++) {
          const cellAddr = char + '' + (j + 2);

          workSheet.getCell(cellAddr).protection = {
            locked: false,
          };
        }
      }

      // console.log(workSheet);

      const res = await workSheet.protect('password', {
        selectUnlockedCells: true,
        autoFilter: true,
      });
    };

    if (!excelFileName.includes('error')) func();

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      FileSaver.saveAs(blob, excelFileName);
    });

    return;
  }

  public exportAsExcelFile(json: any[], excelFileName: string, headers: string[]): void {
    const workbook = this.getWorkbook1(json, headers, excelFileName);

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public exportExcelFileStyle(json: any[], excelFileName: string, headers: string[]) {
    const workbook = this.getWorkbook(json, headers, excelFileName);
    XLSXSTYLE.writeFile(workbook, excelFileName);
  }

  public exportExcelFileStyle1(json: any[], excelFileName: string, headers: string[]) {
    const workbook = this.getWorkbook3(json, headers, excelFileName);
    XLSXSTYLE.writeFile(workbook, excelFileName);
  }

  public getFileBuffer(json: any[], excelFileName: string, headers: string[]) {
    const workbook = this.getWorkbook(json, headers, excelFileName);

    const excelBuffer: any = XLSXSTYLE.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    return excelBuffer;
  }

  // private saveAsExcelFile(buffer: any, fileName: string): void {
  //   const data: Blob = new Blob([buffer], {
  //     type: EXCEL_TYPE,
  //   });
  //   FileSaver.saveAs(data, `${fileName}_export${EXCEL_EXTENSION}`);
  // }

  // getUploadedData() {
  //   return this.uploadedData;
  // }
  

  getUploadedData() {
    return this.uploadedData;
  }

  exportAsExcelFileAirfreight(
    json: any[], // Data to export
    excelFileName: string, // Name of the exported file
    headers: string[] // Array of headers to include in the file
  ): void {
    // Map of English headers to Japanese translations
  

    // Generate the Japanese headers for the second row
    

    // Call the getWorkbook2 function with all required arguments
    const workbook = this.getWorkbook2(json, headers, excelFileName);

    // Generate the Excel buffer from the workbook
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx', // Specify the file format (xlsx)
      type: 'array', // Output type is an array (useful for saving the file)
    });

    // Save the generated Excel file
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private getWorkbook2(
    json: any[], // Data to export
    headers: string[], // English headers
    // Japanese headers
    excelFileName: string // Name of the Excel file
  ): XLSX.WorkBook {
    // Prepare worksheet data: First row is headers, second row is Japanese headers, followed by the data rows
    const worksheetData = [
  headers, // First row contains the headers
  ...json // Data rows start immediately after the headers
];

    // Create the worksheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Create the workbook
    const workbook: XLSX.WorkBook = {
      SheetNames: ['Sheet1'], // Sheet name (can be changed)
      Sheets: {
        Sheet1: worksheet, // Name the sheet
      },
    };

    return workbook;
  }

public saveAsExcelFile(buffer: any, fileName: string): void {
  const data: Blob = new Blob([buffer], {
    type: EXCEL_TYPE,
  });
  
  // Using FileSaver stream mechanism to save the file.
  const stream = new ReadableStream({
    start(controller) {
      controller.enqueue(data);
      controller.close();
    }
  });
    const reader = stream.getReader();
    const chunks: any[] = [];

    reader.read().then(function processText({ done, value }) {
      if (done) {
        const finalBlob = new Blob(chunks, { type: EXCEL_TYPE });
        FileSaver.saveAs(finalBlob, `${fileName}_export${EXCEL_EXTENSION}`);
        return;
      }
      chunks.push(value);
      reader.read().then(processText);
    });
}

private getWorkbookModuleStocking(json: any[], headers: string[], excelFileName: string) {
  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, {});

  const range = XLSX.utils.decode_range(worksheet['!ref'] as string);
  for (let C = range.s.c; C <= range.e.c; C++) {
    const address = `${XLSX.utils.encode_col(C)}1`; // <-- first row
    if (!worksheet[address]) {
      continue;
    }
    worksheet[address].v = headers[C];
  }
  const wscols: any = [];
  for (const [index, head] of headers.entries()) {
    // columns length added
    let wch = head.length + 7;
    switch (head.toLowerCase()) {
      case 'user':
        wch = 30;
        break;

    }
 
    // Force "part no" and "kanban" columns to be string type
    if (['dock','renban', 'module', 'plan stock time', 'status', , 'actual stock dt/time', 'user'].includes(head.toLowerCase())) {
      for (let rowIndex = 0; rowIndex < range.e.r; rowIndex++) {
        const address = `${XLSX.utils.encode_col(index)}${rowIndex + 2}`;
        if (worksheet[address]) {
          worksheet[address].v=worksheet[address].v ?? '';
          worksheet[address].t = 's'; // Set type to string (Text)
          worksheet[address].z = '@'; // Optional: format as text explicitly
        }
        if(rowIndex==0){
          const address1 = `${XLSX.utils.encode_col(index)}${rowIndex + 1}`;
          if (worksheet[address1]) {
            worksheet[address1].v=worksheet[address1].v ?? '';
            worksheet[address1].t = 's'; // Set type to string (Text)
            worksheet[address1].z = '@'; // Optional: format as text explicitly
          }
        }
      }
    }
    else if (['plan lo dt', 'plan stock dt'].includes(head.toLowerCase())) {
      for (let rowIndex = 0; rowIndex < range.e.r; rowIndex++) {
        const address = `${XLSX.utils.encode_col(index)}${rowIndex + 2}`;
        if (worksheet[address] && worksheet[address].v !== null) {
          const val = new Date(worksheet[address].v);
          if (!isNaN(val.getTime())) {
                  worksheet[address].t = 'n';                        // number (Excel date)
                  worksheet[address].v = this.toExcelDate(worksheet[address].v);        // Excel serial date
                  worksheet[address].z = 'mm/dd/yyyy';               // display format
                } else {
                  worksheet[address].t = 'd';
                }
         
        }
        if(rowIndex==0){
          const address1 = `${XLSX.utils.encode_col(index)}${rowIndex + 1}`;
          if (worksheet[address1]) {
            worksheet[address1].v=worksheet[address1].v ?? '';
            worksheet[address1].t = 's'; // Set type to string (Text)
            worksheet[address1].z = '@'; // Optional: format as text explicitly
          }
        }
      }
    }
    else if (['shift', 'plan veh'].includes(head.toLowerCase())) {
      for (let rowIndex = 0; rowIndex < range.e.r; rowIndex++) {
        const address = `${XLSX.utils.encode_col(index)}${rowIndex + 2}`;
        if (worksheet[address] && !isNaN(worksheet[address].v)) {
          worksheet[address].t = 'n'; // Set type to number
          worksheet[address].z = '0';
          worksheet[address].v = Number(worksheet[address].v);
        }
        if(rowIndex==0){
          const address1 = `${XLSX.utils.encode_col(index)}${rowIndex + 1}`;
          if (worksheet[address1]) {
            worksheet[address1].v=worksheet[address1].v ?? '';
            worksheet[address1].t = 's'; // Set type to string (Text)
            worksheet[address1].z = '@'; // Optional: format as text explicitly
          }
        }
      }
    }

    wscols.push({ wch });
  }
  worksheet['!cols'] = wscols;
  

  const workbook: XLSX.WorkBook = {
    Sheets: { sheet_1: worksheet },
    SheetNames: ['sheet_1'],
  };

  return workbook;
}



public excelModuleStocking(json: any[], excelFileName: string, headers: string[]): void {
  const workbook = this.getWorkbookModuleStocking(json, headers, excelFileName);

  const excelBuffer: any = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  this.saveAsExcelFile(excelBuffer, excelFileName);
}

private getWorkbook3(json: any[], headers: string[], excelFileName: string) {
  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, {});
  const range = XLSX.utils.decode_range(worksheet['!ref'] as string);

  for (let C = range.s.c; C <= range.e.c; C++) {
    const address = `${XLSX.utils.encode_col(C)}1`; // Header row
    if (!worksheet[address]) continue;
    worksheet[address].v = headers[C];
  }

  const wscols: any = [];

  for (const [index, head] of headers.entries()) {
    let wch = head.length + 7;

    // Set custom column widths
    switch (head.toLowerCase()) {
      case 'cc': wch = 3; break;
      case 'van dt': wch = 12; break;
      case 'part no': wch = 14; break;
      case 'kanban': wch = 8; break;
      case 'qpc':
      case 'spc': wch = 8; break;
      case 'fa min original':
      case 'fa max original':
      case 'fa min final':
      case 'fa max final': wch = head.length; break;
      case 'updated dt': wch = 20; break;
      case 'user': wch = 30; break;
      case 'comments': wch = 140; break;
      case 'remarks':
      case 'errors':
      case 'error': wch = 50; break;
    }

    // Mark date columns
    if (
      !excelFileName.includes('flal') &&
      head.toUpperCase().includes('DT') &&
      !head.toUpperCase().includes('UPDATE')
    ) {
      for (let rowIndex = 0; rowIndex < range.e.r; rowIndex++) {
        const address = `${XLSX.utils.encode_col(index)}${rowIndex + 2}`;
        if (worksheet[address] && worksheet[address].v !== null) {
          const val = new Date(worksheet[address].v);
          if (!isNaN(val.getTime())) {
            worksheet[address].t = 'd'; // Set type to date
          }
        }
      }
    }

    // Force "part no" and "kanban" columns to be string type
    if (['partno','part number', 'kanban'].includes(head.toLowerCase())) {
      for (let rowIndex = 0; rowIndex < range.e.r; rowIndex++) {
        const address = `${XLSX.utils.encode_col(index)}${rowIndex + 2}`;
        if (worksheet[address]) {
          worksheet[address].v=worksheet[address].v ?? '';
          worksheet[address].t = 's'; // Set type to string (Text)
          worksheet[address].z = '@'; // Optional: format as text explicitly
        }
        if(rowIndex==0){
          const address1 = `${XLSX.utils.encode_col(index)}${rowIndex + 1}`;
          if (worksheet[address1]) {
            worksheet[address1].v=worksheet[address1].v ?? '';
            worksheet[address1].t = 's'; // Set type to string (Text)
            worksheet[address1].z = '@'; // Optional: format as text explicitly
          }
        }
      }
    }

    wscols.push({ wch });
  }

  worksheet['!cols'] = wscols;

  const workbook: XLSX.WorkBook = {
    Sheets: { sheet_1: worksheet },
    SheetNames: ['sheet_1'],
  };

  return workbook;
}
public downloadStockingExcel(json: any[], excelFileName: string, headers: string[]) {
  const workbook = new ExcelJS.Workbook();
  const workSheet = workbook.addWorksheet('StockingPaceMaintenace');

  workSheet.addRow(headers);

  workSheet.autoFilter = {
    from: {
      row: 1,
      column: 1
    },
    to: {
      row: 1,
      column: headers.length
    }
  };

  for (const row of json) {
    workSheet.addRow(
      Object.values(row).map((value: any) => {
        if (!excelFileName.includes('error') && typeof value === 'string' && value.includes('/')) {
          return new Date(value);
        }
        return value;
      })
    );
  }
  

  for (let iCount = 0; iCount < headers.length; iCount++) {
    let width = headers[iCount].length;

    switch (headers[iCount].toLowerCase()) {
      case 'business entity':
        width = 18;
        break;
      case 'dock':
        width = 10;
        break;
      case 'container renban':
        width = 20;
        break;
      case 'module number':
        width = 17;
        break;
        case 'stocking pace':
          width = 17;        
          // Align only the header cell (row 1)
          workSheet.getCell(1, iCount + 1).alignment = { horizontal: 'left' };        
          // Align data cells (row 2 onwards)
          workSheet.getColumn(iCount + 1).eachCell((cell, rowNumber) => {
            if (rowNumber > 1) {
              cell.alignment = { horizontal: 'right' };
            }
          });
          break;
      case 'comments':
        width = 100;
        break;
      default :
        width = 50;
    }

    workSheet.getColumn(iCount + 1).width = width;

  }


  const func = async () => {
    // module_number till end
    for (let index = 4; index < headers.length; index++) {
      const char = String.fromCharCode(index + 65);

      for (let j = 0; j < json.length; j++) {
        const cellAddr = char + '' + (j + 2);

        workSheet.getCell(cellAddr).protection = {
          locked: false,
        };
      }
    }

    // console.log(workSheet);

    const res = await workSheet.protect('password', {
      selectUnlockedCells: true,
      autoFilter: true,
    });
  };

  //if (!excelFileName.includes('error')) func();

  func();
  workbook.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    FileSaver.saveAs(blob, excelFileName);
  });

  return;
}

  toExcelDate(dateStr: string): number {
    const [mm, dd, yyyy] = dateStr.split('/').map(Number);

    // Excel epoch: 1899-12-30
    const excelEpoch = Date.UTC(1899, 11, 30);
    const targetDate = Date.UTC(yyyy, mm - 1, dd);

    return (targetDate - excelEpoch) / 86400000;
  }

  checkExcelFileName(excelFileName: string): boolean {
    switch (true) {
      case excelFileName.startsWith('OrderForecast_'):
        return true;
      case excelFileName.startsWith('OrderForecast_Error'):
        return true;
      case excelFileName.startsWith('AdjustmentInquiry_'):
        return true;
      case excelFileName.startsWith('Rundown-Maintenance_'):
        return true;
      case excelFileName.startsWith('Pipeline Inquiry'):
        return true;
      case excelFileName.startsWith('ContainerMaintenance'):
        return true;
      case excelFileName.startsWith('Seal Verification'):
        return true;
      case excelFileName.startsWith('Parts Maintenance'):
        return true;
     case excelFileName.startsWith('Stockingpaceinquiry_'):
        return true;
     case excelFileName.startsWith('Stockingpace-maintenance_'):
        return true;
     case excelFileName.startsWith('Container-ordering_'):
        return true;
     case excelFileName.startsWith('Container-Tap_'):
        return true;
     case excelFileName.startsWith('ProductionProgress'):
        return true;
    case excelFileName.startsWith('DevanningHistory_'):
        return true;
     case excelFileName.startsWith('Fluctuation-Allowance_'):
        return true;
    // FOR RUNDOWN ERROR
    case excelFileName.includes('_error_'):
    return true;
  
      default: 
        return false; 
    }
  }
  
    checkExcelColumnName(head: string): boolean {
    switch (true) {
      case head.toUpperCase() === 'VAN DT':
        return true;
      case head.toUpperCase() === 'PROD DT':
        return true;
      case head.toUpperCase() === 'ADJ DT':
        return true;
      case head.toUpperCase() === 'CALC DT':
        return true;
      case head.toUpperCase() === 'ORDER DT':
        return true;
      case head.toUpperCase() === 'VAN COMP DT':
        return true;
      case head.toUpperCase() === 'TAP DT':
        return true;
      case head.toUpperCase() === 'VESS SAIL DT':
        return true;
      case head.toUpperCase() === 'EST ARR DT':
        return true;
      case head.toUpperCase() === 'ACT ARR DT':
        return true;
      case head.toUpperCase() === 'DEVAN DT':
        return true;
      case head.toUpperCase() === 'VANNING FROM':
        return true;
      case head.toUpperCase() === 'VANNING TO':
        return true;
      case head.toUpperCase() === 'ESTD ARRIVAL DT':
        return true;
      case head.toUpperCase() === 'ACTUAL ARRIVAL DT':
        return true;
      case head.toUpperCase() === 'ESTIMATED ARRIVAL':
        return true;
      case head.toUpperCase() === 'PLANNED STOCK DATE':
        return true;
     case head.toUpperCase() === 'STOCKING DATE':
        return true;
      //PROD PROGRESS
      case head.toUpperCase().startsWith('PLAN LO DT'):
        return true;
    
      default:
        return false;
    }
  }
}